<template>
  <main>
    <router-view></router-view>
    <GlobalLoading />
  </main>
</template>

<script>
import GlobalLoading from "@/components/common/GlobalLoading.vue"

export default {
  name: 'app',
  components: {
    GlobalLoading,
  }
}
</script>

<style lang="scss">
    // CoreUI Icons Set
    // @import '~@coreui/icons/css/coreui-icons.min.css';
    /* Import Font Awesome Icons Set */
    $fa-font-path: '~font-awesome/fonts/';
    @import '~font-awesome/scss/font-awesome.scss';
    /* Import Simple Line Icons Set */
    // $simple-line-font-path: '~simple-line-icons/fonts/';
    // @import '~simple-line-icons/scss/simple-line-icons.scss';
    /* Import Flag Icons Set */
    // @import '~flag-icon-css/css/flag-icon.min.css';
    /* Import Bootstrap Vue Styles */
    @import '~bootstrap-vue/dist/bootstrap-vue.css';
    // Import Main styles for this application
    @import 'assets/scss/style';
</style>
